import styled from 'styled-components'

const StyledStep = styled.div `
 
`

export default StyledStep
